"use client";

import { useState } from "react";
import { Check, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { RangeInput } from "@/components/ui/range-input";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const strengths = [{
  id: 1,
  text: "Apostilla de documentos oficiales ante la SEGOB"
}, {
  id: 2,
  text: "Búsqueda de Actas de Nacimiento en todo México"
}, {
  id: 3,
  text: "Tramitación de Antecedentes Penales Federales"
}, {
  id: 4,
  text: "Validación de Títulos y Cédulas Profesionales"
}, {
  id: 5,
  text: "Envíos internacionales seguros vía DHL y FedEx"
}, {
  id: 6,
  text: "Asesoría experta para trámites de extranjería"
}];
const offers = [{
  id: 0,
  title: "Actas de Registro Civil",
  basePrice: 45,
  pricePerUnit: 15,
  unit: "por copia certificada adicional",
  description: "Obtención de actas de nacimiento, matrimonio o defunción en formato digital y físico."
}, {
  id: 1,
  title: "Apostilla Federal",
  basePrice: 85,
  pricePerUnit: 25,
  unit: "por documento extra",
  description: "Legalización internacional de documentos emitidos por autoridades federales mexicanas."
}, {
  id: 2,
  title: "Antecedentes Penales",
  basePrice: 120,
  pricePerUnit: 35,
  unit: "incluye validación consular",
  description: "Constancia de antecedentes registrales federales necesaria para visas y residencias."
}, {
  id: 3,
  title: "Paquete Profesional",
  basePrice: 250,
  pricePerUnit: 50,
  unit: "incluye legalización SEP",
  description: "Apostilla de títulos, certificados de estudio y cédulas para ejercicio en el extranjero."
}];
function formatPrice(price: number): string {
  return price.toLocaleString("en-US", {
    minimumFractionDigits: 0
  }).replace(",", "'");
}
export default function CompanyStrengthsAndPricing() {
  const [activeOffer, setActiveOffer] = useState(2);
  const [sliderValue, setSliderValue] = useState(1);
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const offer = offers[activeOffer];
  const totalPrice = offer.basePrice + (sliderValue - 1) * offer.pricePerUnit;
  const handlePrev = () => setActiveOffer(prev => (prev - 1 + offers.length) % offers.length);
  const handleNext = () => setActiveOffer(prev => (prev + 1) % offers.length);
  return null;
}